import {
  Alert,
  AlertIcon,
  Box,
  Card,
  Container,
  Icon,
  Spinner,
  Text,
  VStack,
  useColorModeValue
} from "@chakra-ui/react";
import { SearchIcon } from "@chakra-ui/icons";

export const IncludedServicesLoadingState = ({ bgGradient, loadingText }) => (
  <Box
    minH="100vh"
    bgGradient={bgGradient}
    display="flex"
    alignItems="center"
    justifyContent="center"
  >
    <VStack spacing={6}>
      <Spinner size="xl" thickness="4px" color="purple.500" speed="0.65s" emptyColor="gray.200" />
      <VStack spacing={2}>
        <Text fontSize="lg" color="gray.600" fontWeight="medium">
          {loadingText}
        </Text>
      </VStack>
    </VStack>
  </Box>
);

export const IncludedServicesErrorState = ({ bgGradient, title, error }) => (
  <Box minH="100vh" bgGradient={bgGradient} p={6}>
    <Container maxW="container.md">
      <Alert
        status="error"
        borderRadius="2xl"
        variant="solid"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        textAlign="center"
        height="200px"
      >
        <AlertIcon boxSize="40px" mr={0} />
        <Text fontSize="lg" mt={4} mb={1}>
          {title}
        </Text>
        <Text color="whiteAlpha.900">{error}</Text>
      </Alert>
    </Container>
  </Box>
);

export const IncludedServicesNoResultsState = ({ searchTerm, title, description }) => (
  <Card
    textAlign="center"
    py={12}
    bg={useColorModeValue("white", "gray.800")}
    borderRadius="2xl"
    shadow="lg"
    border="2px"
    borderColor={useColorModeValue("gray.200", "gray.700")}
  >
    <VStack spacing={4}>
      <Icon as={SearchIcon} color="gray.400" boxSize={12} />
      <Text fontSize="xl" fontWeight="bold" color="gray.500">
        {title}
      </Text>
      <Text color="gray.400" maxW="md" mx="auto">
        {description} "{searchTerm}"
      </Text>
    </VStack>
  </Card>
);

export const IncludedServicesEmptyState = ({ title, description }) => (
  <Card
    textAlign="center"
    py={16}
    bg={useColorModeValue("white", "gray.800")}
    borderRadius="2xl"
    shadow="lg"
    border="2px dashed"
    borderColor={useColorModeValue("gray.300", "gray.600")}
  >
    <VStack spacing={6}>
      <Box
        w="100px"
        h="100px"
        bg="purple.100"
        borderRadius="full"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Text fontSize="4xl">📄</Text>
      </Box>
      <VStack spacing={3}>
        <Text fontSize="2xl" fontWeight="bold" color="gray.500">
          {title}
        </Text>
        <Text color="gray.400" maxW="md" mx="auto">
          {description}
        </Text>
      </VStack>
    </VStack>
  </Card>
);
